module.exports = __webpack_public_path__ + "static/media/flute.afac214b.svg";